import { useCallback } from "react";
import { useAppDispatch } from "../../services/hooks";
import {
  addNotification,
  NotificationType,
} from "../../services/slices/notification";

export const useNotification = () => {
  const dispatch = useAppDispatch();

  const showNotification = useCallback(
    (
      message: string,
      type: NotificationType = "info",
      autoClose = true,
      duration = 3000,
    ) => {
      dispatch(
        addNotification({
          message,
          type,
          autoClose,
          duration,
        }),
      );
    },
    [dispatch],
  );

  const showError = useCallback(
    (message: string, autoClose = true) => {
      showNotification(message, "error", autoClose);
    },
    [showNotification],
  );

  const showSuccess = useCallback(
    (message: string, autoClose = true) => {
      showNotification(message, "success", autoClose);
    },
    [showNotification],
  );

  const showWarning = useCallback(
    (message: string, autoClose = true) => {
      showNotification(message, "warning", autoClose);
    },
    [showNotification],
  );

  const showInfo = useCallback(
    (message: string, autoClose = true) => {
      showNotification(message, "info", autoClose);
    },
    [showNotification],
  );

  return {
    showNotification,
    showError,
    showSuccess,
    showWarning,
    showInfo,
  };
};
